import { Draggable } from 'react-beautiful-dnd';
import TacticCard from 'components/TacticCard/TacticCard';
import { Tactic } from 'generated/maya.types';

type DraggableTacticProps = {
  tactic: Tactic;
  index: number;
  allGroupedTactics: Record<string, Tactic[]>;
  isOnlyOneTactic?: boolean;
  isDragDisabled?: boolean;
  readOnly?: boolean;
  isTacticGroupingImprovementsEnabled: boolean;
  isDeleteDisabled: boolean;
  isMoveDisabled: boolean;
  onMoveToStep: (tacticId: string, step: string, index: number) => Promise<void>;
  onCreateStepFromTacticAtStart: (tacticId: string) => Promise<void>;
  onCreateStepFromTactic: (tacticId: string, placeholderId: string) => Promise<void>;
  onTacticDeleted?: (deletedTacticId: string) => Promise<void>;
};

const DraggableTactic = ({
  tactic,
  index,
  allGroupedTactics,
  isOnlyOneTactic,
  isDragDisabled = false,
  readOnly = false,
  isDeleteDisabled,
  isMoveDisabled,
  isTacticGroupingImprovementsEnabled,
  onMoveToStep,
  onCreateStepFromTacticAtStart,
  onCreateStepFromTactic,
  onTacticDeleted,
}: DraggableTacticProps) => {
  return (
    <Draggable
      draggableId={ tactic._id }
      index={ index }
      isDragDisabled={ isDragDisabled || isOnlyOneTactic }
    >
      {
        (dragProvided) => (
          <div
            ref={ dragProvided.innerRef }
            { ...dragProvided.draggableProps }
            { ...dragProvided.dragHandleProps }
          >
            <TacticCard
              tactic={ tactic }
              allGroupedTactics={ allGroupedTactics }
              readOnly={ readOnly }
              isDeleteDisabled={ isDeleteDisabled }
              isMoveDisabled={ isMoveDisabled }
              isTacticGroupingImprovementsEnabled={ isTacticGroupingImprovementsEnabled }
              onMoveToStep={ onMoveToStep }
              onCreateStepFromTacticAtStart={ onCreateStepFromTacticAtStart }
              onCreateStepFromTactic={ onCreateStepFromTactic }
              onTacticDeleted={ onTacticDeleted }
            />
          </div>
        )
      }
    </Draggable>
  );
};

export default DraggableTactic;
